<onsip-header-main>
  <onsip-header-page-title>{{
    "ONSIP_I18N.MUSIC_ON_HOLD" | translate | sentenceCase
  }}</onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="loadingStateComplete$" [loadingMessage]="text">
  <form
    [formGroup]="musicOnHoldForm"
    (ngSubmit)="onSubmit()"
    class="music-on-hold-form onsip-grid-placement"
  >
    @if (mohPricingProperties$ | async; as mohPricingProperties) { @if
    (mohEnhancedPricingProperties$ | async; as mohEnhancedPricingProperties) {
    <div class="pricing-container">
      <p>
        <span class="semi-bold">{{ "ONSIP_I18N.PRICING" | translate }}:</span>
        {{
          pricingTexts[mohPricingProperties.packagePlan]
            | translate
              : {
                  linePricing: mohPricingProperties.featurePricing,
                  enhancedPricing: mohEnhancedPricingProperties.featurePricing
                }
        }}
      </p>
    </div>
    } }
    <div class="inputs-container">
      <mat-slide-toggle
        [attr.data-cy]="E2eLocators.ADMIN_MOH_ENABLE_TOGGLE"
        formControlName="isEnabled"
        color="primary"
      >
        <span class="mat-bodyADMIN_MOH_MUSIC_SOURCE_TABLE-2">
          {{
            musicOnHoldForm.get("isEnabled")?.value
              ? ("ONSIP_I18N.MUSIC_ON_HOLD" | translate) +
                " " +
                ("ONSIP_I18N.ENABLED" | translate | lowercase)
              : ("ONSIP_I18N.ENABLE" | translate) +
                " " +
                ("ONSIP_I18N.MUSIC_ON_HOLD" | translate | lowercase)
          }}
        </span>
      </mat-slide-toggle>
    </div>
    <mat-divider class="separator"></mat-divider>
    @if (musicOnHoldForm.get('isEnabled')?.value) {
    <div
      [class.disabled-music-on-hold]
      [attr.data-cy]="E2eLocators.ADMIN_MOH_PAGE_EDIT_CONTENT"
      class="inputs-container"
    >
      <h2>{{ "ONSIP_I18N.MY_SETTINGS" | translate }}</h2>
      <div
        class="channels-control-container"
        [ngClass]="{ 'view-mode': (isEditMode$ | async) === false }"
      >
        <div class="settings-item">
          <div class="mat-body-1">
            <span [innerText]="'ONSIP_I18N.PARKING_LOT_NUMBER_OF_CHANNELS' | translate"></span>
            @if (mohPricingProperties$ | async; as mohPricingProperties) {
            <mat-icon
              class="tooltip"
              [matTooltip]="pricingExampleTexts[mohPricingProperties.packagePlan] | translate"
              matTooltipClass="onsip-tooltip-background"
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
            }
          </div>
          <div class="mat-body-2">
            @if (isEditMode$ | async) {
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="channelsAmount"
                [attr.data-cy]="E2eLocators.ADMIN_MOH_SELECT_CHANNELS"
              >
                @for (amount of channelOptions; track amount) {
                <mat-option
                  [value]="amount"
                  [attr.data-cy]="E2eLocators.ADMIN_MOH_SELECT_CHANNELS_OPTION"
                >
                  {{ amount }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            } @else {
            {{ musicOnHoldForm.get("channelsAmount")?.value }}
            }
          </div>
        </div>
        <div class="settings-item" [ngClass]="{ 'mt-24': (isEditMode$ | async) === false }">
          <div class="mat-body-1">
            <span [innerText]="'ONSIP_I18N.STREAM_TYPE' | translate"></span>
            <mat-icon
              class="tooltip"
              [matTooltip]="
                'ONSIP_I18N.DEFAULT_MUSIC_STREAMS_ARE_FREE_UPGRADING_TO_ENHANCED_ALLOWS_YOU_TO_ADD_CUSTOM_STREAMS_FOR_AN_ADDITIONAL_MONTHLY_CHARGE'
                  | translate
              "
              matTooltipClass="onsip-tooltip-background"
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </div>
          <div class="mat-body-2">
            @if (isEditMode$ | async) {
            <mat-radio-group formControlName="isEnhanced" class="radio-group" color="primary">
              <mat-radio-button
                [attr.data-cy]="E2eLocators.ADMIN_MOH_DISABLE_IS_ENHANCED"
                [value]="false"
                >{{ "ONSIP_I18N.DEFAULT" | translate }}</mat-radio-button
              >
              <mat-radio-button
                [attr.data-cy]="E2eLocators.ADMIN_MOH_SET_IS_ENHANCED"
                [value]="true"
              >
                {{ "ONSIP_I18N.ENHANCED" | translate }}
                @if (mohPricingProperties$ | async; as mohPricingProperties) { @if
                (mohPricingProperties.packagePlan !== userPackagePlan.UNLIMITED) { @if
                (mohEnhancedPricingProperties$ | async; as mohEnhancedPricingProperties) {
                {{
                  "ONSIP_I18N.ADDITIONAL_PRICEMONTH"
                    | translate : { price: mohEnhancedPricingProperties.featurePricing }
                }}
                } } }
              </mat-radio-button>
            </mat-radio-group>
            @if (musicOnHoldForm.get('isEnhanced')?.value) {
            <button
              mat-button
              color="primary"
              (click)="manageMusicOnHold()"
              type="button"
              class="manage-button"
            >
              <mat-icon>add</mat-icon>
              {{ "ONSIP_I18N.ADD_MUSIC_STREAM" | translate }}
            </button>
            } } @else {
            {{
              musicOnHoldForm.get("isEnhanced")?.value
                ? ("ONSIP_I18N.ENHANCED" | translate)
                : ("ONSIP_I18N.DEFAULT" | translate)
            }}
            }
          </div>
        </div>
        @if ((isEditMode$ | async) === false) {
        <div class="settings-item mt-24">
          <div class="mat-body-1">{{ "ONSIP_I18N.MUSIC_STREAM" | translate }}</div>
          <div class="mat-body-2">
            {{ musicOnHoldForm.get("defaultSource")?.value?.name }}
          </div>
        </div>
        }
      </div>
    </div>
    @if (isEditMode$ | async) {
    <div class="settings-item mt-24">
      <div class="mat-body-1">{{ "ONSIP_I18N.MUSIC_STREAM" | translate }}</div>
      <div class="mat-body-2" [attr.data-cy]="E2eLocators.ADMIN_MOH_MUSIC_SOURCE_TABLE">
        <mat-radio-group formControlName="defaultSource" color="primary">
          <onsip-table-two
            matSort
            multiTemplateDataRows
            class="data-table"
            [dataSource]="dataSource"
            [trackBy]="trackById"
            [useGrid]="true"
            [hoverable]="true"
          >
            <!-- source name-->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                "ONSIP_I18N.NAME" | translate
              }}</mat-header-cell>
              <mat-cell *matCellDef="let source">
                <mat-radio-button
                  [disabled]="
                    !musicOnHoldForm.controls['isEnhanced'].value &&
                    !source.url?.startsWith('local_stream')
                  "
                  [value]="source"
                >
                  <div class="text-ellipsis">
                    {{ source.name }}
                  </div>
                </mat-radio-button>
              </mat-cell>
            </ng-container>
            <!-- source url-->
            <ng-container matColumnDef="sources">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                "ONSIP_I18N.SOURCE" | translate
              }}</mat-header-cell>
              <mat-cell *matCellDef="let source">
                <span class="text-ellipsis">
                  {{
                    source.url?.startsWith("local_stream")
                      ? ("ONSIP_I18N.DEFAULT" | translate)
                      : source.url
                  }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let source">
                @if ( !source.url?.startsWith('local_stream') &&
                musicOnHoldForm.controls['isEnhanced'].value ) {
                <div class="controls-wrapper">
                  <button
                    type="button"
                    color="primary"
                    (click)="onEditSource(source)"
                    mat-icon-button
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    type="button"
                    (click)="removeItem(source, $event)"
                    color="primary"
                    mat-icon-button
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                }
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </onsip-table-two>
        </mat-radio-group>
      </div>
    </div>
    }
    <div class="page-view-controls" [ngClass]="{ 'buttons-right': isEditMode$ | async }">
      @if ((isEditMode$ | async) === false) {
      <button
        [attr.data-cy]="E2eLocators.ADMIN_MOH_LAUNCH_EDIT"
        mat-flat-button
        type="button"
        color="primary"
        [disabled]="!musicOnHoldForm.get('isEnabled')?.value"
        (click)="onEdit()"
      >
        {{ "ONSIP_I18N.EDIT_SETTINGS" | translate }}
      </button>
      } @if (isEditMode$ | async) {
      <button
        color="primary"
        mat-button
        type="button"
        (click)="onCancelEdit()"
        [attr.data-cy]="E2eLocators.ADMIN_MOH_EDIT_CREATE_CANCEL_EDIT"
        [disabled]="musicOnHoldForm.invalid"
      >
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      } @if (isEditMode$ | async) {
      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="second-button"
        [attr.data-cy]="E2eLocators.ADMIN_MOH_EDIT_CREATE_SAVE_SETTINGS"
        [disabled]="musicOnHoldForm.invalid"
      >
        {{ "ONSIP_I18N.SAVE_SETTINGS" | translate }}
      </button>
      }
    </div>
    }
  </form>
</onsip-loading-container>
<div class="contact-tagline">
  <span>
    {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a [routerLink]="views.CONTACT_SUPPORT" class="primary-500 contact-link">{{
      "ONSIP_I18N.SUPPORT_TEAM" | translate | titlecase
    }}</a>
  </span>
</div>
